// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ExecutionResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /payroll/execution/{id}
 *
 * Returns a single `payment_rule_executions` row, enriched with the JOIN'd
 * `payment_rules` columns (`rule_type`, `rule_amount`) and `payroll_periods`
 * columns (`period_start_date`, `period_end_date`, `period_status`) — the flat
 * shape produced by Payment_rule_executions_model::getDetails()->execution.
 *
 * The dados IS this object (object-shaped dados, default `getDados()`), so the
 * fields are declared directly as public typed properties on the Response —
 * mirroring `Payroll_ExecutionRow`. This gives the generated TS a concrete
 * `interface` AND a non-empty runtime schema for `registerResponseContract`,
 * so `validateResponse` checks each field. A bare single-Row `getDados()`
 * override (`return $this->execution;`) would project to `{}` at runtime.
 *
 * Money columns (`base_amount`, `revenue_tracked`, `expenses_tracked`,
 * `total_deductions`, `net_amount`, `rule_amount`) are MySQL DECIMAL(10,2)
 * and surface as PHP strings via mysqli — declared as `string` to match.
 * `calculation_meta` is a raw JSON column (string).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_ExecutionResponseDados {
id: number
payroll_period_id: number
payment_rule_id: number
user_id: string
franchise_id: number
base_amount: string
total_deductions: string
net_amount: string
status: string
created_at: string
updated_at: string
despesa_id?: number
revenue_tracked?: string
expenses_tracked?: string
calculation_meta?: string
paid_at?: string
rule_type?: string
rule_amount?: string
period_start_date?: string
period_end_date?: string
period_status?: number
}

export type Payroll_ExecutionResponse = ApiResponse<Payroll_ExecutionResponseDados>;

registerResponseContract('Payroll_ExecutionResponse', {
  id:                { type: 'number',  required: true },
  payroll_period_id: { type: 'number',  required: true },
  payment_rule_id:   { type: 'number',  required: true },
  user_id:           { type: 'string',  required: true },
  franchise_id:      { type: 'number',  required: true },
  base_amount:       { type: 'string',  required: true },
  total_deductions:  { type: 'string',  required: true },
  net_amount:        { type: 'string',  required: true },
  status:            { type: 'string',  required: true },
  created_at:        { type: 'string',  required: true },
  updated_at:        { type: 'string',  required: true },
  despesa_id:        { type: 'number',  required: false },
  revenue_tracked:   { type: 'string',  required: false },
  expenses_tracked:  { type: 'string',  required: false },
  calculation_meta:  { type: 'string',  required: false },
  paid_at:           { type: 'string',  required: false },
  rule_type:         { type: 'string',  required: false },
  rule_amount:       { type: 'string',  required: false },
  period_start_date: { type: 'string',  required: false },
  period_end_date:   { type: 'string',  required: false },
  period_status:     { type: 'number',  required: false },
})
